export var ALL_PERMISSIONS = [{
  id: 1,
  name: "CreateUser",
  description: "Permission to create new users"
}, {
  id: 2,
  name: "ViewUser",
  description: "Permission to view users"
}, {
  id: 3,
  name: "CreateOrder",
  description: "Permission to create orders"
}, {
  id: 4,
  name: "SubmitOrder",
  description: "Permission to submit orders"
}, {
  id: 5,
  name: "ViewOrder",
  description: "Permission to view orders"
}];